<template>
    <div>
        <section class="add-course-two-section" id="form-id">
            <h4 class="title text-left squiggly-line-color">
                {{ courseName }}
            </h4>
            <h5 class="heading">Add Videos</h5>
            <div class="add-course-two-wrapper">
                <div class="add-video-item">
                    <!--<div class="left" style="position: relative">-->
                    <!--<img src="http://www.placeimg.com/250/178/any" />-->
                    <!--<label for="add-video" class="">-->
                    <!--<font-awesome-icon icon="plus"></font-awesome-icon>-->
                    <!--<span>(Click here)</span>-->
                    <!--&lt;!&ndash;            add class file added when video file is selected&ndash;&gt;-->
                    <!--</label>-->
                    <!--<b-form-file-->
                    <!--id="add-video"-->
                    <!--v-model="videoFile"-->
                    <!--class="mt-3"-->
                    <!--plain-->
                    <!--@change="videoUpload"-->
                    <!--&gt;-->
                    <!--</b-form-file>-->
                    <!--&lt;!&ndash;          uploading status of selected file&ndash;&gt;-->
                    <!--&lt;!&ndash;<div class="uploading-status" style="width: 40%"></div>&ndash;&gt;-->
                    <!--<div style="position: absolute;bottom: 10px;left: 100px;" v-if="disableButton">-->
                    <!--<b-spinner style="color: red;" label="Spinning"></b-spinner>-->
                    <!--</div>-->
                    <!--<div  v-if="showError && !videoUrl" style="display:block;width: 100%;margin-top: 0.25rem;font-size: 90%;">-->
                    <!--<small style="color: #dc3545;">Please upload video</small>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="right">-->
                    <b-form
                            v-if="show"
                            data-vv-scope="addVideo"
                            @submit.prevent="action('addVideo')"
                    >
                        <div class="col-12 mb-4" style="position: relative;">
                            <span class="p-3"> Upload Video </span>
                            <div style="width: 560px; height: 300px;outline: dashed 1px;">
                                <video
                                        :src="videoUrl"
                                        style="width: 550px; height: 300px;"
                                ></video>
                            </div>
                            <button class="btn-danger"
                                    style="position: absolute ; top: 1px; right: 1px;"
                                    v-if="videoEdit"
                                    @click="videoEdit = false ; videoUrl = ''"
                            >
                                <font-awesome-icon :icon="['far', 'edit']" />
                                Edit video
                            </button>
                            <label
                                    for="add-video"
                                    class=""
                                    style="position: absolute; bottom: 115px;left: 240px"
                                    v-if="!videoEdit"
                            >
                                <font-awesome-icon icon="plus"></font-awesome-icon>
                                <span>(Click here)</span>
                                <!--            add class file added when video file is selected-->
                                <b-form-file
                                        style="display: none"
                                        id="add-video"
                                        v-validate="'required|ext:mp4'"
                                        accept="video/*"
                                        :class="{ 'is-invalid': errors.has('addVideo.Video') }"
                                        class="mt-3"
                                        plain
                                        name="Video"
                                        @change="videoUpload"
                                        v-model="imageFile"
                                >
                                </b-form-file>
                            </label>
                            <b-form-invalid-feedback
                                    id="add-video-error-feedback"
                                    style="display: block"
                            >
                                <small>{{ errors.first("addVideo.Video") }}</small>
                            </b-form-invalid-feedback>
                        </div>
                        <b-form-group
                                id="input-group-1"
                                label=""
                                label-for="input-1"
                                description=""
                                class="col-12"
                        >
                            <b-form-input
                                    id="input-1"
                                    v-model="videoName"
                                    type="text"
                                    required
                                    placeholder="Title"
                                    v-validate="
                  'required|regex:^[A-Za-z0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _-]*$'
                "
                                    :class="{ 'is-invalid': errors.has('addVideo.Video Name') }"
                                    name="Video Name"
                            ></b-form-input>
                            <b-form-invalid-feedback id="add-video-error-feedback">
                                <small>{{ errors.first("addVideo.Video Name") }}</small>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group
                                id="input-group-1"
                                label=""
                                label-for="input-1"
                                description=""
                                class="col-12"
                        >
                            <b-form-textarea
                                    id="input-1"
                                    v-model="description"
                                    type="text"
                                    required
                                    placeholder="Description"
                                    v-validate="'required|min:20|max:256'"
                                    :class="{ 'is-invalid': errors.has('addVideo.Description') }"
                                    name="Description"
                            ></b-form-textarea>
                            <b-form-invalid-feedback id="add-video-error-feedback">
                                <small>{{ errors.first("addVideo.Description") }}</small>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <property-template
                                :show-error="showError"
                                :show-prop-error="showPropError"
                                :property-keys="PropertyKeys"
                                :properties="videoProperties"
                                @updateProperties="updateProperties"
                        />
                        <div class="m-2" style="text-align:right">
                            <b-button
                                    pill
                                    size="md"
                                    class="mt-2 pl-5 pr-5"
                                    @click="action('addVideo')"
                                    :disabled="disableButton"
                            >
                                Add
                            </b-button>
                        </div>
                    </b-form>
                    <!--</div>-->
                </div>
                <div class="video-list-wrapper">
                    <div
                            class="added-video-item"
                            v-for="(video, index) in videoList"
                            :key="index"
                    >
                        <div class="left">
                            <video
                                    :src="video.videoUrl"
                                    style="width: 230px;height: 200px; object-fit: contain"
                            />
                        </div>
                        <div class="right">
                            <p class="title">{{ video.videoName }}</p>
                            <p class="description mt-2">{{ video.description }}</p>
                            <div class="row">
                                <div class="delete" @click="editVideo(video,index)">
                                    <font-awesome-icon
                                            :icon="['far', 'edit']"
                                    ></font-awesome-icon>
                                    <span class="ml-2">Edit</span>
                                </div>
                                <div class="delete" @click="removeVideo(video)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                    <span class="ml-2">Delete</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-holder" style="text-align: right">
                    <b-button size="sm" pill variant="primary" @click="goToHome">
            <span>
              <font-awesome-icon icon="arrow-left"></font-awesome-icon
              ></span>
                    </b-button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {fileUploadApis} from "../../services/adminApis/fileUploadApis";
    import {entityVideo} from "../../services/adminApis/VideoEntityApi";
    import {mapGetters} from "vuex";
    import PropertyTemplate from "../components/propertyTemplate";

    export default {
        components: {PropertyTemplate},
        name: "add-video",
        computed: {
            ...mapGetters("adminAuth", ["getToken"])
        },
        data() {
            return {
                courseId: "",
                courseName: "",
                videoList: [],
                videoFile: "",
                imageFile: "",
                videoName: "",
                description: "",
                videoUrl: "",
                imageUrl: "",
                videoId: "",
                videoQuality: "",
                videoLanguage: "",
                videoProperties: [],
                show: true,
                disableButton: false,
                videoEdit: false,
                showError: false,
                totalVideos: "",
                showPropError: false,
                PropertyKeys: ["Quality", "Medium of Instruction"]
            };
        },
        methods: {
            action(scope) {
                this.$validator.validateAll(scope).then(result => {
                    if (
                        result &&
                        this.videoUrl &&
                        this.videoProperties &&
                        this.videoProperties.length > 0
                    ) {
                        this.showError = false;
                        this.showPropError = false
                        this.AddVideo();
                    } else if (this.videoProperties && this.videoProperties.length === 0) {
                        this.showPropError = true;
                        this.showError = true;
                    } else {
                        this.showError = true;
                    }
                });
            },
            AddVideo() {
                if (this.videoList.length < this.totalVideos) {
                    const videoData = {
                        videoName: this.videoName,
                        videoProperties: this.videoProperties,
                        courseId: this.courseId,
                        description: this.description,
                        videoUrl: this.videoUrl,
                        imageUrl: this.imageUrl
                    };
                    if (this.videoEdit) {
                        videoData.videoId = this.videoId;
                        entityVideo.editVideo(videoData, this.getToken).then(() => {
                            this.getVideoList();
                            this.resetForm();
                            this.$bvToast.toast(`Video Edited Successfully`, {
                                title: "Edit video",
                                autoHideDelay: 500,
                                appendToast: true
                            });
                        });
                    } else {
                        entityVideo.addVideo(videoData, this.getToken).then(() => {
                            this.getVideoList();
                            this.resetForm();
                            this.$bvToast.toast(`Video Added Successfully`, {
                                title: "Add video",
                                autoHideDelay: 500,
                                appendToast: true
                            });
                        });
                    }
                } else {
                    this.$bvToast.toast(`Total Video Limit Exceeded`, {
                        title: "Add video",
                        autoHideDelay: 500,
                        appendToast: true
                    });
                }
            },
            editVideo(video, index) {
                this.showEditForm();
                this.videoList.splice(index, 1);
                this.videoEdit = true;
                this.videoName = video.videoName;
                this.courseId = video.courseId;
                this.description = video.description;
                this.videoUrl = video.videoUrl;
                this.imageUrl = video.imageUrl;
                this.videoId = video.videoId;
                this.videoProperties = video.videoProperties;

            },
            removeVideo(video) {
                entityVideo.removeVideo(video.videoId, this.getToken).then(() => {
                    this.getVideoList();
                    this.$bvToast.toast(`Video Deleted Successfully`, {
                        title: "Delete video",
                        autoHideDelay: 500,
                        appendToast: true
                    });
                });
            },
            updateProperties(propList) {
                this.videoProperties = propList;
            },
            setData() {
                this.courseId = this.$route.query.courseId;
                this.courseName = this.$route.query.courseName;
                this.totalVideos = this.$route.query.totalVideos;
            },
            getVideoList() {
                entityVideo.getVideoByCourseId(this.$route.query.courseId).then(res => {
                    this.videoList = res.data;
                });
            },
            videoUpload(event) {
                if (this.videoList.length < this.totalVideos) {
                    this.disableButton = true;
                    const formData = new FormData();
                    formData.append("document", event.target.files[0]);
                    fileUploadApis.videoUpload(formData, this.getToken).then(res => {
                        this.disableButton = false;
                        this.videoUrl = res.data.VideoUrl;
                    });
                } else {
                    this.$bvToast.toast(`Total Video Limit Exceeded`, {
                        title: "Add video",
                        autoHideDelay: 500,
                        appendToast: true
                    });
                }
            },
            resetForm() {
                this.videoName = "";
                this.videoProperties = [];
                this.description = "";
                this.videoUrl = "";
                this.imageUrl = "";
                this.videoId = "";
                this.videoQuality = "";
                this.videoLanguage = "";
                this.show = false;
                this.$nextTick(() => {
                    this.show = true;
                });
            },
            goToHome() {
                if (this.videoList.length === 0) {
                    this.$bvToast.toast(`Add Atleast 1 Video`, {
                        title: "Add Video",
                        autoHideDelay: 500,
                        appendToast: true
                    });
                } else {
                    this.$router.push({
                        path: "/admin/dashboard"
                    });
                }
            },
            uploadImage(event) {
                const formData = new FormData();
                formData.append("document", event.target.files[0]);
                fileUploadApis.imageUpload(formData, this.getToken).then(res => {
                    this.imageUrl = res.bodyText;
                });
            },
            showEditForm() {
                if (document.readyState === "complete") {
                    const EditForm = document.getElementById("form-id");
                    EditForm.scrollIntoView();
                }
            }
        },
        mounted() {
            this.setData();
            this.getVideoList();
        }
    };
</script>

<style scoped></style>
